import localStorageUtil from '@/common/utils/localStorageUtil';
import LoadingIndicator from '@/component/common/LoadingIndicator';
import serviceFactory from '@/service/ServiceFactory';
import { Redirect, Route } from 'react-router-dom';
import './header/HeaderTop.css';
import Utils from '@/common/utils/utils';

const WrapLayoutRoute = ({ component: Component, wrapLayout: WrapLayout, ...rest }) => {
    let corporationDomain = localStorageUtil.getCorporationDomain();
    let params = rest.computedMatch.params;
    let pathname = rest.computedMatch.path;
    let orgCode = params.orgCode;
    let orgInvitation = params?.orgInvitation;
    let arrPathName = pathname.split('/');
    let subDomain = orgInvitation ? orgInvitation : orgCode;

    let isLogScreen = false;
    let urlLink = `/${orgCode}`;
    switch (arrPathName[2]) {
        case 'p':
            urlLink = `/${orgCode}/p/${orgInvitation}`;
            if (pathname.includes('log-screen')) {
                isLogScreen = true;
            }
            break;
        case 'c':
            urlLink = `/${orgCode}/c/${orgInvitation}`;
            if (pathname.includes('log-screen/bulk-actions')) {
                isLogScreen = true;
            }
            break;
        case 'log-screen':
            isLogScreen = true;
            break;
        default:
            urlLink = `/${orgCode}`;
            break;
    }

    const linkUrlSingedIn = Utils.getCurrentUrlCaseLogin(subDomain);
    if (
        (subDomain && subDomain !== corporationDomain) ||
        (window.location.pathname !== linkUrlSingedIn && arrPathName?.length && arrPathName?.length >= 3 && !isLogScreen)
    ) {
        return (
            <Route
                {...rest}
                render={props =>
                    rest.authState === 'signedIn' ? (
                        <Redirect
                            to={{
                                pathname: linkUrlSingedIn,
                                state: { from: props.location }
                            }}
                        />
                    ) : (
                        <Redirect
                            to={{
                                pathname: `/login${urlLink}`,
                                state: { from: props.location }
                            }}
                        />
                    )
                }
            />
        );
    }
    return (
        <Route
            {...rest}
            render={props =>
                rest.authState === 'loading' ? (
                    <LoadingIndicator isLoading={true} />
                ) : rest.authState === 'signedIn' ? (
                    <WrapLayout>
                        <Component {...rest} {...props} />
                    </WrapLayout>
                ) : (
                    <Redirect
                        to={{
                            pathname: localStorageUtil.getLastLoginCorpDomain()
                                ? `/login/${localStorageUtil.getLastLoginCorpDomain()}`
                                : '/login',
                            state: { from: props.location }
                        }}
                    />
                )
            }
        />
    );
};

export default serviceFactory(WrapLayoutRoute);
